<template>
  <authorization permissionKey="attendance_medical_request" can="read">
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text">
          Solicitações Médicas
        </v-col>

        <authorization
          permissionKey="attendance_medical_request"
          can="save"
          v-slot:default="{ authorization }"
        >
          <v-col cols="auto" v-if="authorization">
            <v-btn
              color="light-blue"
              :to="`/prontuario/${attendance.id}/solicitacao-exames/nova`"
              :dark="!attendanceEsigned"
              :disabled="attendanceEsigned"
              v-if="showAddButton"
            >
              Adicionar
            </v-btn>
          </v-col>
        </authorization>
      </v-row>

      <v-row>
        <v-col class="mx-3">
          <MedicalRequestsFilters @submit="updateFilters" />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <MedicalRequestList
            :attendance="attendance"
            :disabled="attendanceEsigned"
            :filters="filters"
          />
        </v-col>
      </v-row>
    </v-container>
  </authorization>
</template>

<script>
import MedicalRequestList from "@/components/medical_request/list/index.vue";
import MedicalRequestsFilters from "@/views/medical_requests/filters.vue";
import { moment } from "@/config/vue/plugins/moment.js";

export default {
  name: "MedicalRequests",
  props: {
    attendance: Object,
    attendanceEsigned: Boolean,
  },
  data() {
    return {
      filters: {},
      patientId: this.attendance.patient.id,
      attendances: [],
    };
  },
  components: {
    MedicalRequestList,
    MedicalRequestsFilters,
  },
  apollo: {
    attendancesByPatient: {
      query: require("@/graphql/attendance/attendances_by_patient.gql"),
      variables() {
        return {
          patientId: this.patientId,
        };
      },
      result({ data }) {
        if (data && data.attendancesByPatient) {
          this.attendances = data.attendancesByPatient;
          clearInterval(this.interval);
        }
      },
    },
  },

  computed: {
    showAddButton() {
      if (!Array.isArray(this.attendances) || this.attendances.length === 0) {
        return true;
      }
      const firstAttendance = this.attendances[0];
      return moment(this.attendance.createdAt).isSame(firstAttendance.createdAt, 'day');
    },
  },
  methods: {
    updateFilters(filters) {
      this.filters = filters;
    },
  },
};
</script>

<style lang="scss" scoped></style>

